module.exports = __webpack_public_path__ + "media/images/hn-5-e1cfca50.jpg";